<template>
    <Paper :header="label">
        <div v-if="isLoading" class="pt-2 pb-1">
            <ListItemSkeleton v-for="i in 4" :key="i" mini :rows="3" />
        </div>

        <div v-else>
            <ListItem
                v-for="v in data"
                :id="v.id"
                :key="v.id"
                classes="py-3"
                :image="v.image"
                :header="v.header"
                :subheader="v.subheader"
                :subtitle="v.subtitle"
                icon="map-marker-alt"
                :to="toItem(v)"
            />
        </div>

        <slot />
    </Paper>
</template>

<script>
import { buildIDParam } from '~/utils/urlUtils';
import ListItem from './ListItem';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton';

export default {
    components: { ListItem, ListItemSkeleton },
    props: {
        label: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => [],
        },
        to: {
            type: String,
            required: true,
        },
    },

    methods: {
        toItem(item) {
            return {
                name: this.to,
                params: {
                    id: buildIDParam(item.id, item.header),
                    requestId: item.requestId,
                    eventId: item.eventId,
                },
            };
        },
    },
};
</script>

<style scoped></style>
